import React, { useContext } from "react";
import { InformationListContext } from "../../../provider/InformationListProvider";
import { InformationItem } from "./InformationItem";

export const InformationList = React.memo(function InformationList() {
    const {
        displayInformationList
    } = useContext(InformationListContext);

    return (
        <div className={"information_list"}>
            <ul className={"information_list__body"}>
                {displayInformationList.map((information) =>
                    <InformationItem
                        key={information.id.value}
                        information={information}
                    />
                )}
            </ul>
        </div>
    );
});
